import { Routes, RouterModule, ExtraOptions } from '@angular/router';

// services
import { AuthGuard } from './_shared/route-guards/authGuard';

// pages
import { LayoutComponent } from './_layout/layout.component';
import { SsoLoginV5Component } from './login/ssologinV5.component';
import { LogoutComponent } from './logout/logout.component';
import { LoginV2Component } from './login/login-v2.component';
import { ImpersonateComponent } from './login/impersonate.component';
import { EntraCallbackComponent } from './login/entra-callback.component';
import { B2CCallbackComponent } from './login/b2c-callback.component';
import { ErrorsComponent } from './errors/errors.component';

export const routes: Routes = [
  { path: 'login-entra-callback', component: EntraCallbackComponent, data: { title: 'Resolving'} },
  { path: 'login-b2c-callback', component: B2CCallbackComponent, data: { title: 'Resolving'} },
  { path: 'b2c-callback', component: B2CCallbackComponent, data: { title: 'Resolving'} },
  { path: 'login', component: LoginV2Component, data: { title: 'Login' } },
  { path: 'impersonate', component: ImpersonateComponent, data: { title: 'Impersonate' } },
  { path: 'ssoLoginV5', component: SsoLoginV5Component },
  { path: 'logout', component: LogoutComponent },
  { path: 'errors', component: ErrorsComponent},
  {
    path: '',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [] // dynamic routes injected at runtime
  }, {
    path: 'resources',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      id: 'resources',
      title: 'Resources',
      breadcrumb: 'Resources',
      allowAnonymous: true,
      hideFilters: true
    },
    loadChildren: () => import('./resources/resources.module').then(m => m.ResourcesModule)
  }, {
    path: 'management',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      id: 'management',
      title: 'Management',
      breadcrumb: 'Management',
      roles: ['System Administrator', 'System Analyst'],
      hideFilters: true
    },
    loadChildren: () => import('./management/management.module').then(m => m.ManagementModule)
  }, {
    path: 'external-link',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      id: 'external-link',
      title: '',
      breadcrumb: '',
      allowAnonymous: true
    },
    loadChildren: () => import('./external-link/external-link.module').then(m => m.ExternalLinkModule)
  },
  {
    path: 'custom-reports',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      id: 'custom-reports',
      title: 'Custom Reports',
      breadcrumb: '',
      allowAnonymous: true
    },
    loadChildren: () => import('./custom-reports/custom-reports.module').then(m => m.CustomReportsModule),
  },
  {
    path: 'ai',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    data: {
      id: 'ai',
      title: 'Paragon AI',
      breadcrumb: '',
      allowAnonymous: true
    },
    loadChildren: () => import('./paragon/paragon.module').then(m => m.ParagonModule),
  }
];

const extraOptions: ExtraOptions = { enableTracing: false, useHash: false, onSameUrlNavigation: 'reload' };
export const AppRouter = RouterModule.forRoot(routes, extraOptions);
